import { AlertCircle } from '@saleshandy/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { accessibleOnClick } from '../../../../../../../../shared/utils/accessible-on-click';
import { PrimaryValueChangeAlertModalProps } from './types';
import { RootState } from '../../../../../../../../store/root-reducer';
import { getIsRequestPending } from '../../../../../../../../shared/utils';

const PrimaryValueChangeAlertModal: React.FC<PrimaryValueChangeAlertModalProps> = ({
  show,
  onHide,
  onConfirm,
  modalTitle,
  modalContent,
}) => {
  const getPrimaryEmailChange = useSelector(
    (state: RootState) => state.prospect.changePrimaryEmailInProspectRequest.status
  );

  const getUpdatePrimaryNumber = useSelector(
    (state: RootState) => state.prospect.updatePrimaryNumberRequest.status
  );

  const isLoading = getIsRequestPending(getPrimaryEmailChange) ||
    getIsRequestPending(getUpdatePrimaryNumber);

  return (
    <Modal
      show={show}
      onHide={onHide}
      className="primary-value-change-alert-modal"
      backdrop="static"
      centered
    >
      <div className="primary-value-change-alert-modal-container">
        <div className="primary-value-change-alert-modal-content">
          <div className="primary-value-change-alert-modal-header">
            <div className="header-title">
              <AlertCircle width={24} height={24} color="#D97706" />
              <span className="line-height-1">
                {modalTitle || 'Changing the primary value'}
              </span>
            </div>
          </div>

          <div className="primary-value-change-alert-modal-body">
            <span className="primary-value-change-alert-modal-text">
              {modalContent || 'Are you sure you want to update it?'}
            </span>
          </div>
        </div>

        <div className="divider-line" />
      </div>

      <div className="primary-value-change-alert-modal-footer">
        <div className="cancel-btn" {...accessibleOnClick(onHide)}>Cancel</div>

        <div className="proceed-btn" {...accessibleOnClick(onConfirm)}>
          <Button variant="primary" disabled={isLoading}>
            {isLoading ? 'Processing…' : 'Yes'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PrimaryValueChangeAlertModal;
